import React from "react";
import styles from "../../../Handbook.module.css";

export type TabItem<T extends string> = {
    key: T;
    label: string;
};

interface HandbookTabsProps<T extends string> {
    tabs: Array<TabItem<T>>;
    active: T;
    onChange: (key: T) => void;
}

export const HandbookTabs = <T extends string>({
                                                   tabs,
                                                   active,
                                                   onChange,
                                               }: HandbookTabsProps<T>) => {

    return (
        <div className={styles.tabs}>
            {tabs.map((t) => {
                const isActive = t.key === active;

                return (
                    <button
                        key={t.key}
                        type="button"
                        className={`${styles.tabButton} ${isActive ? styles.tabButtonActive : ""}`}
                        onClick={() => onChange(t.key)}
                    >
                        {t.label}
                    </button>
                );
            })}
        </div>
    );
};
